import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OfflineRequestHandlerService } from '../services/offline-request-handler.service';

@Injectable()
export class OfflineInterceptor implements HttpInterceptor {

  constructor(private requestHandler: OfflineRequestHandlerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.requestHandler.handleRequest(request, next);
  }
}
